import {first, map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {collection, collectionData, doc, DocumentData, Firestore, limit, orderBy, query} from '@angular/fire/firestore';


export function readDocumentWithId<T>(doc: Observable<DocumentData>): Observable<T> {

  return <any>doc
    .pipe(
      map(action => {

        if(!action) {
          return undefined;
        }

        return {...action, id: action.id}
      })
    );
}

export function readDocumentValue<T>(doc: Observable<DocumentData>): Observable<T> {

  return <any>doc
    .pipe(
      map(action => action)
    );
}


export function readCollectionWithIds<T>(col: Observable<DocumentData[]>): Observable<T> {

  return <any>col
    .pipe(
      map(snaps => snaps.map(snap => {

          // return snap
          return {...snap, id: snap.id}
      })),
      first()
    );
}

export function findUniqueMatchWithId<T>(col: Observable<(DocumentData | (DocumentData & {}))[]>): Observable<T | null> {


  return <any>col
    .pipe(
      map(results => {

        if (results.length > 1) {
          console.log("Collection",col);
          console.log("results",results);
          throw 'Found multiple matches to a unique result query v2.';
        }

        let result = null;

        if (results.length == 1) {

          result = { ...results[0], id: results[0].id }

        }
        return result;
      })
    );
}

export function findLastBySeqNo<T>(afs: Firestore, collectionPath: string): Observable<T> {

  const constraints = [
    orderBy('seqNo', 'desc'),
    limit(1)
  ]
  
  const collectionData$ = collectionData(query(collection((afs as Firestore), collectionPath), ...constraints), {idField: "id"});

  return findUniqueMatchWithId(collectionData$).pipe(first()) as Observable<T>

}

export function createFirestoreId(firestore: Firestore) {
  return doc(collection(firestore, '_')).id;
}
